import { useRef, useEffect } from "react";

export const HTMLContent = ({ html, ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const scripts = ref.current.getElementsByTagName("script");
      for (let script of scripts) {
        const newScript = document.createElement("script");
        newScript.text = script.text; // Copy nội dung script
        document.body.appendChild(newScript); // Chạy script
      }
    }
  }, [html]); // Chạy lại nếu html thay đổi

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
};
